import {FC} from 'react'
import {CONTAINER_PADDING, CONTAINER_PADDING_MOBILE, CONTAINER_WIDTH} from 'theme/sizing'

import {MOBILE_SCREENSIZE} from '@/utils/styles/breakpoints'

export const Container: FC<React.PropsWithChildren<unknown>> = ({children}) => (
  <>
    <div className="container">{children}</div>

    <style jsx>{`
      .container {
        width: 100%;
        max-width: calc(${CONTAINER_WIDTH} + ${CONTAINER_PADDING} * 2);
        padding: 0 ${CONTAINER_PADDING};
        margin: 0 auto;
      }
      @media ${MOBILE_SCREENSIZE} {
        .container {
          padding: 0 ${CONTAINER_PADDING_MOBILE};
        }
      }
    `}</style>
  </>
)
